/**
 * The Goods Nook — shared scroll-reveal controller.
 * Load once, site-wide, via theme.liquid (see README-IMPLEMENTATION.md).
 *
 * Behavior:
 *  - Adds .nook-js-ready to <html> so nook-motion.css knows JS is active
 *    (elements stay visible-by-default until this runs, so content is never
 *    hidden from users with JS disabled or from crawlers).
 *  - If the visitor has requested reduced motion, every .nook-reveal element
 *    is marked visible immediately — no animation is attempted at all.
 *  - Otherwise, each .nook-reveal element fades/rises in independently the
 *    first time it enters the viewport, via its own IntersectionObserver
 *    entry (not a single page-load timer), so a fast scroll flick on mobile
 *    doesn't fire every section's animation at once.
 */
(function () {
  var root = document.documentElement;
  root.classList.add('nook-js-ready');

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  function revealAll() {
    document.querySelectorAll('.nook-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  function observeAll() {
    document.querySelectorAll('.nook-reveal:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Sections loaded later by the theme editor (e.g. a merchant adding a
  // section while customizing) should still get scroll-reveal behavior.
  document.addEventListener('shopify:section:load', observeAll);

  // Header scroll behavior: adds .is-glass once the page has scrolled past
  // the first viewport, and hides/shows on scroll direction. Only runs if a
  // sticky header with data-nook-header exists (see header restyle notes in
  // README-IMPLEMENTATION.md).
  var header = document.querySelector('[data-nook-header]');
  if (header) {
    var lastScrollY = window.scrollY;
    var ticking = false;

    function onScroll() {
      var currentY = window.scrollY;
      header.classList.toggle('is-glass', currentY > 24);

      if (!prefersReducedMotion) {
        var scrollingDown = currentY > lastScrollY && currentY > 120;
        header.classList.toggle('is-hidden', scrollingDown);
      }

      lastScrollY = currentY;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(onScroll);
          ticking = true;
        }
      },
      { passive: true }
    );
  }
})();
